var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Base from './Base';
import GridColumn from './GridColumn';

var VALIGN_OPTIONS = ['right', 'center', 'top', 'middle', 'bottom', 'around', 'between'];

var Grid = function Grid(_ref) {
  var _classnames;

  var gutter = _ref.gutter,
      align = _ref.align,
      rev = _ref.rev,
      equalHeight = _ref.equalHeight,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ['gutter', 'align', 'rev', 'equalHeight', 'children', 'className']);

  var classes = classnames('o-grid', (_classnames = {}, _defineProperty(_classnames, 'o-grid--' + gutter, gutter), _defineProperty(_classnames, 'o-grid--' + align, align), _defineProperty(_classnames, 'o-grid--rev', rev), _defineProperty(_classnames, 'o-grid--equal-height', equalHeight), _classnames), className);

  return React.createElement(
    Base,
    _extends({ className: classes }, props),
    children
  );
};

Grid.propTypes = {
  gutter: PropTypes.string,
  align: PropTypes.oneOf(VALIGN_OPTIONS),
  rev: PropTypes.bool,
  equalHeight: PropTypes.bool,
  children: PropTypes.node
};

Grid.Column = GridColumn;

export default Grid;